export default __webpack_public_path__ + "static/media/delete.6c14c994.svg";